import { exerciseType } from "../constants/constants";

export default function GenerateFormFilters(
  event,
  settaskquestionType,
  settaskGrammars,
  settaskLevels,
  setQuestypeIcon,
  Dropdownitems,
  formData,
  setFormData
) {
    if (event)
    {
        let { name, value } = event;
        if (name === "exercise_type" && value) {
          let taskExerciseTypes = [];
          let taskgrammars = [];
          let tasklevels = [];
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) => item.task_type === value
          );
          filteredTemp?.forEach((f_item) => {
            tasklevels = tasklevels.concat(
              f_item.task_levels.map((level) => level.value)
            );
            if(f_item.mark_question_type_gpt_reference)
            {
              taskExerciseTypes = taskExerciseTypes.concat(
                f_item.task_exercise_types.map((type) => type.value)
              );
            }
            if(f_item.mark_grammar_gpt_reference)
            {
              taskgrammars = taskgrammars.concat(
                f_item.task_grammars.map((grammar) => grammar.value)
              );
            }
          });
          settaskLevels([...new Set(tasklevels)]);
          settaskquestionType([...new Set(taskExerciseTypes)]);
          settaskGrammars([...new Set(taskgrammars)]);
          setFormData((prevState) => ({
            ...prevState,
            grammar_type: "",
            question_type: "",
          }));
        } 
        else if (formData.exercise_type && name === "cefr_level" && value) {
          let taskExerciseTypes = [];
          let taskgrammars = [];
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === value.split(" ")[0])
          );
          filteredTemp?.forEach((f_item) => {
            if(f_item.mark_question_type_gpt_reference)
            {
              taskExerciseTypes = taskExerciseTypes.concat(
                f_item.task_exercise_types.map((type) => type.value)
              );
            }
            if(f_item.mark_grammar_gpt_reference)
            {
              taskgrammars = taskgrammars.concat(
                f_item.task_grammars.map((grammar) => grammar.value)
              );
            }
          });
          settaskquestionType([...new Set(taskExerciseTypes)]);
          settaskGrammars([...new Set(taskgrammars)]);
          setFormData((prevState) => ({
            ...prevState,
            grammar_type: "",
            question_type: "",
          }));
        } 
        else if (
          formData.exercise_type === exerciseType.GRAMMAR_TASK &&
          formData.cefr_level &&
          name === "grammar_type" &&
          value
        ) {
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level) &&
              item.mark_grammar_gpt_reference &&
              item.task_grammars.some((grammar) => grammar.value === value)
          );
          setFormData((prevState) => ({ ...prevState, question_type: "" }));
          if (filteredTemp?.[0])
          {
            setFormData((prevState) => ({ ...prevState, grammar_reference_id: filteredTemp?.[0].id }));
          }
        }
        if (
          formData.exercise_type &&
          formData.cefr_level &&
          name === "question_type" &&
          value
        ) {
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level) &&
              item.mark_question_type_gpt_reference && 
              item.task_exercise_types.some(
                (q_type) => q_type.value === value
              )
          );
          if (filteredTemp?.[0])
          {
            setQuestypeIcon(filteredTemp?.[0].task_exercise_types.find(
                (question_type) => question_type.value === value
              ).exercise_icon)
            setFormData((prevState) => ({ ...prevState, question_reference_id: filteredTemp?.[0].id }));
          }
        }
    }
    else {
        if (formData.exercise_type) {
          let taskExerciseTypes = [];
          let taskgrammars = [];
          let tasklevels = [];
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) => item.task_type === formData.exercise_type
          );
          filteredTemp?.forEach((f_item) => {
            tasklevels = tasklevels.concat(
              f_item.task_levels.map((level) => level.value)
            );
            taskExerciseTypes = taskExerciseTypes.concat(
              f_item.task_exercise_types.map((type) => type.value)
            );
            taskgrammars = taskgrammars.concat(
              f_item.task_grammars.map((grammar) => grammar.value)
            );
          });
          settaskLevels([...new Set(tasklevels)]);
        } 
        if (formData.exercise_type && formData.cefr_level) {
          let taskExerciseTypes = [];
          let taskgrammars = [];
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level)
          );
          filteredTemp?.forEach((f_item) => {
            taskExerciseTypes = taskExerciseTypes.concat(
              f_item.task_exercise_types.map((type) => type.value)
            );
            taskgrammars = taskgrammars.concat(
              f_item.task_grammars.map((grammar) => grammar.value)
            );
          });
          settaskquestionType([...new Set(taskExerciseTypes)]);
          settaskGrammars([...new Set(taskgrammars)]);
        } 
        if (
          formData.exercise_type === exerciseType.GRAMMAR_TASK &&
          formData.cefr_level &&
          formData.grammar_type
        ) {
          let taskExerciseTypes = [];
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level) &&
              item.task_grammars.some((grammar) => grammar.value === formData.grammar_type)
          );
          filteredTemp?.forEach((f_item) => {
            taskExerciseTypes = taskExerciseTypes.concat(
              f_item.task_exercise_types.map((type) => type.value)
            );
          });
          settaskquestionType([...new Set(taskExerciseTypes)]);
        } 
        if (
          formData.exercise_type === exerciseType.GRAMMAR_TASK &&
          formData.cefr_level &&
          formData.grammar_type &&
          formData.question_type
        ) {
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level) &&
              item.task_grammars.some(
                (grammar) => grammar.value === formData.grammar_type
              ) &&
              item.task_exercise_types.some(
                (question_type) => question_type.value === formData.question_type
              )
          );
          if (filteredTemp?.[0])
          {
              setQuestypeIcon(filteredTemp?.[0].task_exercise_types.find(
                  (question_type) => question_type.value === formData.question_type
                ).exercise_icon)
          }
        }
        if (
          formData.exercise_type &&
          formData.cefr_level &&
          formData.question_type
        ) {
          const filteredTemp = Dropdownitems?.reference_temp?.filter(
            (item) =>
              item.task_type === formData.exercise_type &&
              item.task_levels.some((level) => level.value === formData.cefr_level) &&
              item.task_exercise_types.some(
                (q_type) => q_type.value === formData.question_type
              )
          );
          if (filteredTemp?.[0])
          {
              setQuestypeIcon(filteredTemp?.[0].task_exercise_types.find(
                  (question_type) => question_type.value === formData.question_type
                ).exercise_icon)
          }
        }
    }
}